import React from 'react';
import {NavLink} from 'react-router-dom';



const Aboutnav = () => {
   const activeStyle={color:'lavender',}
   return (
         <ul className="AboutNav">
             <li><NavLink to="/" style={({isActive}) => (isActive ? activeStyle: undefined)}>ABOUT</NavLink></li>
             <li><NavLink to="/Aboutconcept" style={({isActive}) => (isActive ? activeStyle: undefined)}>CONCEPT</NavLink></li>
             <li><NavLink to="/Aboutarchitecture" style={({isActive}) => (isActive ? activeStyle: undefined)}>ARCHITECTURE</NavLink></li>
         </ul>
   );
};

export default Aboutnav;